class GaEvents {

    constructor() {
        this.storeBtns = Array
            .prototype
            .slice
            .call(document.querySelectorAll('.section-hero__text__stores__item'), 0)
        this.storeFooterBtns = Array
            .prototype
            .slice
            .call(document.querySelectorAll('.footer__download__apps__item'), 0)
        this.followFooterBtns = Array
            .prototype
            .slice
            .call(document.querySelectorAll('.footer-follow'), 0)

        this.downloadKit = document.querySelector('.section-press__download__text a')

        this.facebookBtn = document.querySelector('.section-hero__social__li--facebook')
        this.twitterBtn = document.querySelector('.section-hero__social__li--twitter')

        this.init()
    }

    init() {

        this
            .storeBtns
            .map((item) => {
                item.addEventListener('click', () => {
                    this.onStoreClick(item)
                })
            })

        this
            .storeFooterBtns
            .map((item) => {
                item.addEventListener('click', () => {
                    this.onStoreClick(item)
                })
            })

        this
            .downloadKit
            .addEventListener('click', () => {
                this.onDownloadKitClick()
            })

        this
            .facebookBtn
            .addEventListener('click', () => {
                this.onSocialClick('Facebook', 'Share')
            })

        this
            .twitterBtn
            .addEventListener('click', () => {
                this.onSocialClick('Twitter', 'Tweet')
            })

        this
            .followFooterBtns
            .map((item) => {
                item.addEventListener('click', () => {
                    this.onSocialLinkClick(item)
                })
            })

    }

    onStoreClick(item) {
        const store = item.dataset.store
        gtag('event', 'click', {
            'event_category': 'Stores',
            'event_label': store
        });
    }

    onSocialClick(social, action) {
        gtag('event', 'share', {
            'method': social,
            'event_action': action
        });
    }

    onSocialLinkClick(item) {
        const follow = item.dataset.follow

        gtag('event', 'click', {
            'event_category': 'Follow Us',
            'event_label': follow
        });
    }

    onDownloadKitClick() {
        gtag('event', 'click', {
            'event_category': 'Kit Press',
            'event_label': 'Kit Press'
        });
    }

}

export default GaEvents


// WEBPACK FOOTER //
// ./src/js/components/GaEvents.js